module.exports = __webpack_public_path__ + "static/img/goods-null-data.39612e89.png";